import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Mail, MapPin, Phone, UserRound } from 'lucide-react';
import type { Persona } from '@/types';
import type { ParticipantGroup } from './types';

interface ParticipantsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  group: ParticipantGroup;
  participants: Persona[];
  tramiteId: number;
}

const getValue = (value?: string | null) => value || 'No informado';

export const ParticipantsDialog = ({
  open,
  onOpenChange,
  group,
  participants,
  tramiteId,
}: ParticipantsDialogProps) => {
  const title = group === 'vendedores' ? 'Transferentes' : 'Adquirientes';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85dvh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{title} · Trámite #{tramiteId}</DialogTitle>
          <DialogDescription>
            Información de consulta. Los datos no pueden editarse desde esta vista.
          </DialogDescription>
        </DialogHeader>

        {participants.length === 0 ? (
          <p className="rounded-lg border border-dashed p-6 text-center text-sm text-muted-foreground">
            No hay {title.toLowerCase()} registrados.
          </p>
        ) : (
          <div className="space-y-3">
            {participants.map((participant, index) => (
              <article
                key={participant.id ?? `${group}-${index}`}
                className="rounded-lg border bg-muted/30 p-4"
              >
                <h3 className="mb-3 font-semibold text-foreground">
                  {getValue(participant.nombre)}
                </h3>
                <dl className="grid gap-3 text-sm sm:grid-cols-2">
                  <div className="flex gap-2">
                    <UserRound className="mt-0.5 size-4 shrink-0 text-muted-foreground" />
                    <div>
                      <dt className="text-xs text-muted-foreground">DNI</dt>
                      <dd>{getValue(participant.dni ?? participant.profile?.dni)}</dd>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Phone className="mt-0.5 size-4 shrink-0 text-muted-foreground" />
                    <div>
                      <dt className="text-xs text-muted-foreground">Teléfono</dt>
                      <dd>{getValue(participant.telefono ?? participant.profile?.telefono)}</dd>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Mail className="mt-0.5 size-4 shrink-0 text-muted-foreground" />
                    <div>
                      <dt className="text-xs text-muted-foreground">Email</dt>
                      <dd className="break-all">{getValue(participant.email)}</dd>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <MapPin className="mt-0.5 size-4 shrink-0 text-muted-foreground" />
                    <div>
                      <dt className="text-xs text-muted-foreground">Dirección</dt>
                      <dd>{getValue(participant.direccion ?? participant.profile?.direccion)}</dd>
                    </div>
                  </div>
                </dl>
              </article>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
